import React, { useEffect, useState } from 'react';
import './sec3.css'
import CardSec3 from '../components/common/card-sec3';
import pic7 from '../assets/pic7.png'
import pic12 from '../assets/pic12.png'
import pic13 from '../assets/pic13.png'
import pic14 from '../assets/pic14.png'
import { useTranslation } from 'react-i18next';

const Sec3 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

 const [animate, setAnimate] = useState(false);
    const [wasInView, setWasInView] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section = document.querySelector('.sec3');

            if (section) {
                const rect = section.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                const isInView = rect.top < windowHeight && rect.bottom > 0;

                if (isInView && !wasInView) {
                    setAnimate(false);
                    setTimeout(() => {
                        setAnimate(true);
                    }, 50);
                    setWasInView(true);
                }

                if (!isInView && wasInView) {
                    setAnimate(false);
                    setWasInView(false);
                }
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [wasInView]);












    return ( 
        <section className={`sec3 ${animate ? 'animate' : ''}`} dir={direction}>
            <article className='container-sec3'>
                <h1 className='header-sec3'>{t('Upcoming Event')} </h1>
                <article className='cards-container-sec3'>
                    <CardSec3 img={pic7} title={t('Shakira Live in Egypt')}
                    title2={t(' April 7, 2026')}
                    title3={t('4:00 PM - 7:00 PM')}
                    title4={t('Pyramids of Giza')}
                    title5={t('Limited')}
                    price={t('1200 – 5000 EGP')}
                     description=
                     {t(`Join Shakira for a once-in-a-lifetime concert experience at the Pyramids of Giza. Enjoy live music, amazing visuals, and unforgettable performances.`)}/>

                    <CardSec3 img={pic12} title={t('Zamna Festival Egypt')}
                    title2={t('April 24–25, 2026')}
                    title3={t('6:00 PM - 10:00 PM')}
                    title4={t('Pyramids of Giza')}
                    title5={t('Available')}
                    price={t('1500 – 4000 EGP')}
                     description={t("Join Zamna Festival for two days of non-stop music, vibrant performances, and cultural celebration at the Pyramids of Giza. Dance, connect, and make memories with friends at one of Egypt’s most anticipated festivals.")}/>

                    <CardSec3 img={pic13} title={t('Andrea Bocelli Event')}
                    title2={t('May 26, 2026')}
                    title3={t('5:00 PM - 9:00 PM')}
                    title4={t('City of Arts & Culture')}
                    title5={t('Available')}
                    price={t('3000 – 22000 EGP')}
                    description={t('Be enchanted by the timeless voice of Andrea Bocelli at the City of Arts & Culture. This evening promises a breathtaking classical performance, combining emotion, elegance, and world-class artistry for an unforgettable experience.')} />

                    <CardSec3 img={pic14} title={t('Amr Diab Summer')}
                    title2={t('July 13 2026')}
                    title3={t('3:00 PM - 11:00 PM')}
                    title4={t('North Coast')}
                    title5={t('Limited')}
                    price={t('800 – 3000 EGP')}
                    description={t('Celebrate summer with the King of Arabic Pop, Amr Diab, at the North Coast. Sing along to his greatest hits, enjoy a lively atmosphere, and immerse yourself in a magical night of music, lights, and energy.')}/>

                </article>
            </article>
        </section>
     );
}
 
export default Sec3;